<template>
  <div v-if="loaded" class="dsf-sc-super-search">
    <div class="dsf-sc-super-search__field">
      <el-select v-model="fieldValue" @change="fieldChange">
        <el-option v-for="option in fieldOptions" :key="option.id" :label="option.name" :value="option.id" />
      </el-select>
    </div>
    <div class="dsf-sc-super-search__symbol">
      <el-select v-model="symbolValue">
        <el-option v-for="option in symbolOptions" :key="option.value" :label="option.text" :value="option.value" />
      </el-select>
    </div>
    <div v-if="activeField" class="dsf-sc-super-search__value">
      <template v-if="symbolValue == 'isNull' || symbolValue == 'notNull'">
        <el-input value="Null" readonly style="width: 160px;" />
      </template>
      <template v-else-if="symbolValue == 'list' || symbolValue == 'notlist'">
        <dsf-sc-super-search-input v-model="searchValue" placeholder="请输入内容" style="width: 160px;" />
      </template>
      <template v-else-if="activeField.type == 'enum'">
        <el-select v-if="activeField.type == 'enum'" v-model="searchValue" style="width: 160px;">
          <el-option
            v-for="option in activeField.options"
            :key="option.value"
            :label="option.text"
            :value="option.value"
          />
        </el-select>
      </template>
      <template v-else-if="symbolValue == 'range' || symbolValue == 'notrange'">
        <el-date-picker
          v-if="activeField.type == 'datetime'"
          v-model="searchValue"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 260px;"
        />
        <dsf-sc-super-search-number
          v-else-if="activeField.type == 'number'"
          v-model="searchValue"
          style="width: 260px;"
        />
        <el-input
          v-else
          v-model="searchValue"
          placeholder="请输入内容"
          style="width: 260px;"
        />
      </template>
      <template v-else>
        <el-date-picker
          v-if="activeField.type == 'datetime'"
          v-model="searchValue"
          type="date"
          placeholder="请选择时间"
          style="width: 160px;"
        />
        <el-input-number
          v-else-if="activeField.type == 'number'"
          v-model="searchValue"
          :min="1"
          :max="10"
          :controls="false"
          style="width: 160px;"
        />
        <el-input
          v-else
          v-model="searchValue"
          placeholder="请输入内容"
          style="width: 160px;"
        />
      </template>
    </div>
    <div v-else class="dsf-sc-super-search__value">
      <el-input readonly placeholder="请输入内容" style="width: 160px;" />
    </div>
    <div class="dsf-sc-super-search__bt">
      <dsf-button icon="fangdajing">查询</dsf-button>
      <dsf-button type="plain" @click="doSuperSearch">高级查询</dsf-button>
    </div>
  </div>
</template>

<script>
import DsfScSuperSearchInput from './superSearchInput';
import DsfScSuperSearchNumber from './superSearchNumber';

export default {
  name: "DsfScSuperSearch",
  components: {
    DsfScSuperSearchInput,
    DsfScSuperSearchNumber
  },
  props: {
    owner: {
      type: Object,
      default: null
    },
    searchItemSetting: {
      type: Array,
      default() {
        return [];
      }
    },
    // 高级查询页面链接
    superSearchUrl: {
      type: String,
      default: 'http://ysj.52script.com:8080/dsfa/vue/index.html#/query/ad-hoc/709eab51514b4231b7ec0aa6ffa80960'
    },
  },
  data() {
    return {
      loaded: false,
      fieldValue: "",
      fieldOptions: [],
      symbolValue: "list",
      symbolOptions: [
        {text: "等于", value: "eq"},
        {text: "大于", value: "gt"},
        {text: "小于", value: "lt"},
        {text: "大于等于", value: "ge"},
        {text: "小于等于", value: "le"},
        {text: "不等于", value: "ne"},
        {text: "包含", value: "in"},
        {text: "不包含", value: "notin"},
        {text: "匹配", value: "like"},
        {text: "前缀", value: "slike"},
        {text: "后缀", value: "elike"},
        {text: "非前缀", value: "notslike"},
        {text: "非后缀", value: "notelike"},
        {text: "区间", value: "range"},
        {text: "不在区间", value: "notrange"},
        {text: "列表", value: "list"},
        {text: "不在列表", value: "notlist"},
        {text: "前缀列表", value: "slist"},
        {text: "后缀列表", value: "elist"},
        {text: "为空", value: "isNull"},
        {text: "不为空", value: "notNull"},
      ],
      activeField: null,
      searchValue: null
    }
  },
  created() {
    if (!this.owner.isDesign) {
      this.init();
    } else {
      this.loaded = true;
    }
  },
  methods: {
    async init() {
      let optionsMap = {};
      let optionsRequests = [];
      let dictArr = [];
      let fieldOptions = _.map(this.searchItemSetting, ({id, name, type, setting = {}}) => {
        id = toHump(id);
        if (type == 'enum') {
          if (setting?.type == "dict") {
            let params = {
              key: id,
              dictId: setting.value.key
            };
            dictArr.push(params);
          } else if (setting?.type == "dbsource") {
            let path = setting.value.key.replace(/\./g, "/");
            optionsRequests.push({
              id: id,
              request: (params) => {
                let p = {
                  ...(this.owner?.queryString || {}),
                  ...(params || {})
                };
                return this.$webAPI.dbSourceInterface(p, path, true);
              }
            });
          } else if (setting?.type == "interface") {
            optionsRequests.push({
              id: id,
              request: (params) => {
                let p = {
                  ...(this.owner?.queryString || {}),
                  ...(params || {})
                };
                return this.$http.get(this.$replace(setting.value), p, true);
              }
            });
          } else if (setting?.value) {
            optionsMap[id] = setting.value;
          } else {
            optionsMap[id] = [];
          }
        }
        return {id, name, type};
      });
      let res = await this.updateOptions(optionsMap, optionsRequests, dictArr);
      _.each(fieldOptions, el => {
        if (res[el.id]) {
          el.options = res[el.id];
        }
      });
      this.fieldOptions = fieldOptions;
      this.loaded = true;
    },
    async updateOptions(optionsMap, optionsRequests, dictArr) {
      if (dictArr.length > 0) {
        let params = {
          dicts: dictArr
        };
        optionsRequests.unshift({
          id: "dicts",
          request: () => {
            return this.$webAPI.getBatchDict(params, true);
          }
        });
      }
      try {
        let optionsMap2 = await this.loopOptionsHttps(optionsRequests);
        return dsf.mix(optionsMap, optionsMap2, {});
      } catch (err) {
        dsf.layer.message("查询检索选项出现错误,页面无法创建", false);
      }
    },
    loopOptionsHttps(requests, callback) {
      let optionsMap = {};
      return new Promise((reslove, reject) => {
        let index = -1;
        let next = function () {
          index++;
          if (index >= requests.length) {
            reslove(optionsMap);
            return;
          }
          if (requests.length > 0) {
            exec();
          }
        };

        function exec() {
          let opts = requests[index];
          opts
            .request()
            .then(({data}) => {
              if (opts.id == "dicts") {
                for (let k in data.data) {
                  optionsMap[k] = data.data[k];
                }
              } else {
                optionsMap[opts.id] = data.data;
              }
              if (callback) {
                callback(
                  {
                    request: requests[index],
                    data: data.data
                  },
                  next
                );
              } else {
                next();
              }
            })
            .catch((ex) => {
              reject();
            });
        }

        next();
      });
    },
    fieldChange(v) {
      this.activeField = _.find(this.fieldOptions, s => s.id == v);
      if (!this.activeField) return;
      let type = this.activeField.type;
      if (!this.symbolValue) {
        this.symbolValue = 'eq';
      }
      this.searchValue = null;
      if (this.symbolValue != 'range') {
        this.searchValue = getDefaultValue(type);
      } else {
        this.searchValue = [
          getDefaultValue(type),
          getDefaultValue(type)
        ];
      }
    },
    doSuperSearch() {
      let rmiframeUrl = this.superSearchUrl;
      // 客户环境
      if (location.href.indexOf('://10.203.') > 0) {
        rmiframeUrl = rmiframeUrl.replace(/:\/\/[\d\w.:]*\//, '://10.203.132.246:8088/');
      }
      dsf.layer.openDialog({
        title: "高级查询",
        width: "1000px",
        height: "600px",
        content: "DsfDialogIframe",
        params: {
          rmiframeUrl
        },
        btns: [
          {
            text: "确定"
          },
          {
            text: "取消"
          }
        ]
      });
    }
  }
}

function getDefaultValue(type) {
  switch (type) {
    case 'text':
      return '';
    case 'number':
      return 0;
    case 'datetime':
      return null;
    case 'enum':
      return '';
  }
}

// 中横线转换驼峰
function toHump(name) {
  return name.replace(/-(\w)/g, function(all, letter){
    return letter.toUpperCase();
  });
}
</script>